import axios from "axios";


export async function searchPublisher(term, page) {
    const encodedSearchTerm = encodeURIComponent(term);
    const response = await axios.get(`/publisher/search?q=${encodedSearchTerm}&p=${page ?? 1}`);
    const responseData = response.data;

    return {
        publishers: responseData.data,
        pages: responseData.pages,
        filtered: responseData.filtered
    };
}